import { useNavigate } from "react-router-dom";

import { Box, Button, Progressbar, Heading, Link } from "@ogt/ui";

const progress = 0;

export default function Intro() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex justify-end items-center">
        <div className="w-full max-w-xs mb-4">
          <Progressbar percentage={progress} />
        </div>
      </div>
      <Box>
        <Heading id="ageCheckHeading" progress={progress}>
          Innan du börjar din överklagan
        </Heading>
        <p>Använd det här formuläret för att överklaga en tilläggsavgift.</p>

        <ul>
          <li>
            Om du är under 18 år behöver du fylla i en mejladress till en
            vårdnadshavare, god man eller ett ombud som vi kan kontakta.{" "}
          </li>
          <li>
            Om du har en god man eller ett ombud behöver du fylla i den
            personens mejladress så att vi kan kontakta personen.
          </li>
        </ul>

        <p>
          Undrar du över något medan du fyller i formuläret kan du alltid
          kontakta vår kundservice på{" "}
          <Link className="inline!" underline="always" href="tel:0771211010">
            0771 – 21 10 10
          </Link>
          .
        </p>
      </Box>

      <div className="flex justify-center">
        <div className="w-full text-right">
          <Button
            className="w-full sm:w-auto"
            onClick={() => navigate("/tillaggsavgiftsnummer")}
            type="submit"
          >
            Gå vidare
          </Button>
        </div>
      </div>
    </div>
  );
}
